import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ErrorProps {
  code: string | undefined;
}

const translationKeys = {
  LimitExceededException: "resetPassword.errorMessages.limitExceeded",
  CodeMismatchException: "resetPassword.errorMessages.codeMismatch",
  ExpiredCodeException: "resetPassword.errorMessages.codeExpired",
};

const getTranslationKeyFromCode = (code: string | undefined): string => {
  return (
    translationKeys[code as keyof typeof translationKeys] ||
    "resetPassword.errorMessages.unknownError"
  );
};

export default function ResetError({ code }: ErrorProps) {
  const { t } = useTranslation();
  const key = getTranslationKeyFromCode(code);
  const message = t(key);

  if (!code) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-5">
      <TriangleAlert className="w-5 mt-[-4px]" />
      <AlertTitle>{t("resetPassword.errorTitle")}</AlertTitle>
      <AlertDescription>{message}</AlertDescription>
    </Alert>
  );
}
